import CUSTOM_PALETTE from '../../../features/theme/light'

const PALETTE = {
    MuiTypography: {
        ...CUSTOM_PALETTE?.MuiTypography,
        global: 'rgba(34, 36, 41, 1)',
        secondary: 'rgba(0, 0, 0, 0.6)'
    },
    MuiButton: {
        ...CUSTOM_PALETTE?.MuiButton,
        company: {
            background: 'rgba(237, 0, 0, 1)',
            color: 'rgba(255, 255, 255, 1)',
            border: 'rgba(237, 0, 0, 1)',
            hover: 'rgba(186, 0, 0, 1)',
            hoverColor: 'rgba(255, 255, 255, 1)',
            hoverBorder: 'rgba(186, 0, 0, 1)',
            ...CUSTOM_PALETTE?.MuiButton?.company,
        },
        primary: {
            background: 'rgba(51, 96, 246, 1)',
            color: 'rgba(255, 255, 255, 1)',
            border: 'rgba(51, 96, 246, 1)',
            hover: 'rgba(31, 73, 210, 1)',
            hoverColor: 'rgba(255, 255, 255, 1)',
            hoverBorder: 'rgba(31, 73, 210, 1)',
            ...CUSTOM_PALETTE?.MuiButton?.primary,
        },
        secondary: {
            background: 'rgba(0, 0, 0, 0)',
            color: 'rgba(51, 96, 246, 1)',
            border: 'rgba(51, 96, 246, 1)',
            hover: 'rgba(0, 0, 0, 0.05)',
            hoverColor: 'rgba(51, 96, 246, 1)',
            hoverBorder: 'rgba(51, 96, 246, 1)',
            ...CUSTOM_PALETTE?.MuiButton?.secondary,
        },
        tertiary: {
            background: 'rgba(0, 0, 0, 0)',
            color: 'rgba(51, 96, 246, 1)',
            border: 'rgba(0, 0, 0, 0)',
            hover: 'rgba(0, 0, 0, 0.05)',
            hoverColor: 'rgba(51, 96, 246, 1)',
            hoverBorder: 'rgba(0, 0, 0, 0)',
            ...CUSTOM_PALETTE?.MuiButton?.tertiary,
        },
        header: {
            background: 'rgba(0, 0, 0, 0)',
            hover: 'rgba(0, 0, 0, 0.05)',
            color: 'rgba(0, 0, 0, 0.6)',
            colorHover: 'rgba(51, 96, 246, 1)',
            border: 'rgba(51, 96, 246, 1)',
            selectedColor: 'rgba(51, 96, 246, 1)',
            ...CUSTOM_PALETTE?.MuiButton?.header
        }
    },
    Tile: {
        ...CUSTOM_PALETTE?.Tile,
        primary: {
            background: 'rgba(255, 255, 255, 1)',
            border: 'rgba(0, 0, 0, 0.15)',
            hover: 'rgba(233, 235, 238, 1)',
            checked: 'rgba(51, 96, 246, 1)',
            ...CUSTOM_PALETTE?.Tile?.primary,
            color: {
                main: 'rgba(34, 36, 41, 1)',
                hover: 'rgba(34, 36, 41, 1)',
                label: 'rgba(34, 36, 41, 1)',
                hoverLabel: 'rgba(34, 36, 41, 1)',
                sublabel: 'rgba(34, 36, 41, 1)',
                hoverSublabel: 'rgba(34, 36, 41, 1)',
                ...CUSTOM_PALETTE?.Tile?.primary?.color
            }
        }
    },
    toggleGroup: {
        ...CUSTOM_PALETTE?.toggleGroup,
        primary: {
            group: 'rgba(255, 255, 255, 1)',
            border: 'rgba(0, 0, 0, 0.1)',
            ...CUSTOM_PALETTE?.toggleGroup?.primary,
            selected: {
                background: 'rgba(232, 238, 254, 1)',
                color: 'rgba(51, 96, 246, 1)',
                ...CUSTOM_PALETTE?.toggleGroup?.primary?.selected
            },
            hover: {
                background: 'rgba(232, 238, 254, 1)',
                color: 'rgba(51, 96, 246, 1)',
                ...CUSTOM_PALETTE?.toggleGroup?.primary?.hover
            },
            unselected: {
                background: 'rgba(0, 0, 0, 0)',
                color: 'rgba(0, 0, 0, 0.6)',
                ...CUSTOM_PALETTE?.toggleGroup?.primary?.hover
            }
        },
        secondary: {
            group: 'rgba(233, 235, 238, 1)',
            border: 'rgba(0, 0, 0, 0)',
            ...CUSTOM_PALETTE?.toggleGroup?.secondary,
            selected: {
                background: 'rgba(255, 255, 255, 1)',
                color: 'rgba(34, 36, 41, 1)',
                ...CUSTOM_PALETTE?.toggleGroup?.secondary?.selected
            },
            hover: {
                background: 'rgba(255, 255, 255, 1)',
                color: 'rgba(34, 36, 41, 1)',
                ...CUSTOM_PALETTE?.toggleGroup?.secondary?.hover
            },
            unselected: {
                background: 'rgba(0, 0, 0, 0)',
                color: 'rgba(0, 0, 0, 0.6)',
                ...CUSTOM_PALETTE?.toggleGroup?.secondary?.unselected
            }
        }
    },
    MuiCheckbox: {
        ...CUSTOM_PALETTE?.MuiCheckbox,
        primary: {
            unchecked: 'rgba(0, 0, 0, 0.26)',
            checked: 'rgba(51, 96, 246, 1)',
            indeterminate: 'rgba(51, 96, 246, 1)',
            ...CUSTOM_PALETTE?.MuiCheckbox?.primary
        }
    },
    MuiFormLabel: {
        primary: 'rgba(0, 0, 0, 0.6)',
        success: 'rgba(64, 120, 70, 1)',
        ...CUSTOM_PALETTE?.MuiFormLabel
    },
    MuiFormControlLabel: {
        primary: 'rgba(34, 36, 41, 1)',
        ...CUSTOM_PALETTE?.MuiFormControlLabel
    },
    MuiFormHelperText: {
        primary: 'rgba(0, 0, 0, 0.6)',
        ...CUSTOM_PALETTE?.MuiFormHelperText
    },
    MuiRadio: {
        ...CUSTOM_PALETTE?.MuiRadio,
        primary: {
            unchecked: 'rgba(42, 42, 42, 1)',
            checked: 'rgba(42, 42, 42, 1)',
            ...CUSTOM_PALETTE?.MuiRadio?.primary
        }
    },
    MuiSwitch: {
        ...CUSTOM_PALETTE?.MuiSwitch,
        primary: {
            thumb: {
                checked: 'rgba(255, 255, 255, 1)',
                unchecked: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.MuiSwitch?.primary?.thumb
            },
            background: {
                checked: 'rgba(51, 96, 246, 1)',
                unchecked: 'rgba(198, 203, 211, 1)',
                ...CUSTOM_PALETTE?.MuiSwitch?.primary?.background
            },
            ...CUSTOM_PALETTE?.MuiSwitch?.primary
        }
    },
    MuiMenu: {
        ...CUSTOM_PALETTE?.MuiMenu,
        primary: {
            background: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.MuiMenu?.primary
        }
    },
    MuiMenuItem: {
        ...CUSTOM_PALETTE?.MuiMenuItem,
        primary: {
            iconColor: 'rgba(34, 36, 41, 1)',
            iconHoverColor: 'rgba(0, 0, 0, 0.3)',
            background: 'rgba(255, 255, 255, 1)',
            color: 'rgba(34, 36, 41, 1)',
            hoverColor: 'rgba(34, 36, 41, 1)',
            hoverBackground: 'rgba(0, 0, 0, 0.1)',
            selectedColor: 'rgba(34, 36, 41, 1)',
            selectedBackground: 'rgba(0, 0, 0, 0.1)',
            ...CUSTOM_PALETTE?.MuiMenuItem?.primary
        }
    },
    MuiListSubheader: {
        ...CUSTOM_PALETTE?.MuiListSubheader,
        primary: {
            background: 'rgba(255, 255, 255, 1)',
            color: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.MuiListSubheader?.primary
        }
    },
    MuiTabs: {
        ...CUSTOM_PALETTE?.MuiTabs,
        primary: {
            background: 'rgba(0, 0, 0, 0)',
            border: 'rgba(0, 0, 0, 0.15)',
            selectedBorder: 'rgba(51, 96, 246, 1)',
            ...CUSTOM_PALETTE?.MuiTabs?.primary
        }
    },
    MuiTab: {
        ...CUSTOM_PALETTE?.MuiTab,
        primary: {
            background: 'rgba(0, 0, 0, 0)',
            color: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.MuiTab?.primary
        }
    },
    MuiLink: {
        ...CUSTOM_PALETTE?.MuiLink,
        primary: {
            color: 'rgba(51, 96, 246, 1)',
            hover: 'rgba(31, 73, 210, 1)',
            background: 'rgba(0, 0, 0, 0)',
            backgroundHover: 'rgba(0, 0, 0, 0)',
            ...CUSTOM_PALETTE?.MuiLink?.primary
        }
    },
    MuiDialog: {
        ...CUSTOM_PALETTE?.MuiDialog,
        primary: {
            wrapper: 'transparent',
            background: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.MuiDialog?.primary
        }
    },
    MuiDialogTitle: {
        ...CUSTOM_PALETTE?.MuiDialogTitle,
        primary: {
            background: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.MuiDialogTitle?.primary
        }
    },
    MuiDialogContent: {
        ...CUSTOM_PALETTE?.MuiDialogContent,
        primary: {
            background: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.MuiDialogContent?.primary
        }
    },
    MuiDialogActions: {
        ...CUSTOM_PALETTE?.MuiDialogActions,
        primary: {
            background: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.MuiDialogActions?.primary
        }
    },
    MuiLinearProgress: {
        ...CUSTOM_PALETTE?.MuiLinearProgress,
        background: 'rgba(0, 0, 0, 0.15)',
        primary: {
            background: 'rgba(51, 96, 246, 1)',
            ...CUSTOM_PALETTE?.MuiLinearProgress?.primary
        },
        secondary: {
            background: 'rgba(0, 0, 0, 0.15)',
            ...CUSTOM_PALETTE?.MuiLinearProgress?.secondary
        },
        success: {
            background: 'rgba(45, 164, 78, 1)',
            ...CUSTOM_PALETTE?.MuiLinearProgress?.success
        },
        error: {
            background: 'rgba(216, 0, 0, 1)',
            ...CUSTOM_PALETTE?.MuiLinearProgress?.error
        }
    },
    MuiAlert: {
        ...CUSTOM_PALETTE?.MuiAlert,
        info: {
            background: 'rgba(232, 238, 254, 1)',
            border: 'rgba(121, 151, 249, 1)',
            color: 'rgba(31, 73, 210, 1)',
            ...CUSTOM_PALETTE?.MuiAlert?.info
        },
        success: {
            background: 'rgba(226, 243, 207, 1)',
            border: 'rgba(95, 175, 0, 1)',
            color: 'rgba(54, 99, 0, 1)',
            ...CUSTOM_PALETTE?.MuiAlert?.success
        },
        warning: {
            background: 'rgba(252, 240, 154, 1)',
            border: 'rgba(178, 155, 3, 1)',
            color: 'rgba(100, 88, 2, 1)',
            ...CUSTOM_PALETTE?.MuiAlert?.warning
        },
        error: {
            background: 'rgba(254, 234, 234, 1)',
            border: 'rgba(245, 115, 115, 1)',
            color: 'rgba(180, 0, 0, 1)',
            ...CUSTOM_PALETTE?.MuiAlert?.error
        }
    },
    MuiAccordion: {
        iconWrapper: 'rgba(0, 0, 0, 0.6)',
        background: 'rgba(255, 255, 255, 1)',
        border: 'rgba(0, 0, 0, 0.15)',
        ...CUSTOM_PALETTE?.MuiAccordion
    },
    MuiAccordionSummary: {
        background: 'rgba(255, 255, 255, 1)',
        color: 'rgba(46, 46, 46, 1)',
        ...CUSTOM_PALETTE?.MuiAccordionSummary
    },
    MuiPickersLayout: {
        background: 'rgba(255, 255, 255, 1)'
    },
    Textinput: {
        primary: {
            fieldSet: 'rgba(0, 0, 0, 0.15)',
            fieldSetHover: 'rgba(51, 96, 246, 1)',
            fieldSetSuccess: 'rgba(97, 143, 100, 1)',
            color: 'rgba(34, 36, 41, 1)',
            background: 'rgba(255, 255, 255, 1)',
            ...CUSTOM_PALETTE?.Textinput?.primary
        },
        secondary: {
            fieldSet: 'rgba(0, 0, 0, 0.15)',
            fieldSetHover: 'rgba(51, 96, 246, 1)',
            fieldSetSuccess: 'rgba(97, 143, 100, 1)',
            color: 'rgba(34, 36, 41, 1)',
            background: 'rgba(250, 250, 250, 1)',
            ...CUSTOM_PALETTE?.Textinput?.secondary
        },
        ...CUSTOM_PALETTE?.Textinput?.variants
    },
    Datatable: {
        background: 'rgba(255, 255, 255, 1)',
        ...CUSTOM_PALETTE?.Datatable,
        grid: {
            background: 'rgba(0, 0, 0, 0)',
            border: 'rgba(0, 0, 0, 0.15)',
            ...CUSTOM_PALETTE?.Datatable?.grid
        },
        header: {
            background: 'rgba(236, 236, 236, 1)',
            color: '#222B2D',
            ...CUSTOM_PALETTE?.Datatable?.header
        },
        row: {
            error: 'rgba(255, 151, 137, 1)',
            color: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.Datatable?.row
        }
    },
    Tag: {
        ...CUSTOM_PALETTE?.Tag,
        red: {
            ...CUSTOM_PALETTE?.Tag?.red,
            main: {
                background: 'rgba(254, 234, 234, 1)',
                border: 'rgba(245, 115, 115, 1)',
                color: 'rgba(180, 0, 0, 1)',
                ...CUSTOM_PALETTE?.Tag?.red?.main
            },
            contrasted: {
                background: 'rgba(224, 0, 0, 1)',
                border: 'rgba(224, 0, 0, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.red?.contrasted
            }
        },
        green: {
            ...CUSTOM_PALETTE?.Tag?.green,
            main: {
                background: 'rgba(226, 243, 207, 1)',
                border: 'rgba(95, 175, 0, 1)',
                color: 'rgba(54, 99, 0, 1)',
                ...CUSTOM_PALETTE?.Tag?.green?.main
            },
            contrasted: {
                background: 'rgba(68, 124, 0, 1)',
                border: 'rgba(68, 124, 0, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.green?.contrasted
            }
        },
        blue: {
            ...CUSTOM_PALETTE?.Tag?.blue,
            main: {
                background: 'rgba(232, 238, 254, 1)',
                border: 'rgba(121, 151, 249, 1)',
                color: 'rgba(31, 73, 210, 1)',
                ...CUSTOM_PALETTE?.Tag?.blue?.main
            },
            contrasted: {
                background: 'rgba(51, 96, 246, 1)',
                border: 'rgba(51, 96, 246, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.blue?.contrasted
            }
        },
        yellow: {
            ...CUSTOM_PALETTE?.Tag?.yellow,
            main: {
                background: 'rgba(252, 240, 154, 1)',
                border: 'rgba(178, 155, 3, 1)',
                color: 'rgba(100, 88, 2, 1)',
                ...CUSTOM_PALETTE?.Tag?.yellow?.main
            },
            contrasted: {
                background: 'rgba(127, 111, 2, 1)',
                border: 'rgba(127, 111, 2, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.yellow?.contrasted
            }
        },
        grey: {
            ...CUSTOM_PALETTE?.Tag?.grey,
            main: {
                background: 'rgba(236, 237, 239, 1)',
                border: 'rgba(151, 156, 165, 1)',
                color: 'rgba(82, 88, 99, 1)',
                ...CUSTOM_PALETTE?.Tag?.grey?.main
            },
            contrasted: {
                background: 'rgba(104, 111, 124, 1)',
                border: 'rgba(104, 111, 124, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.grey?.contrasted
            }
        },
        orange: {
            ...CUSTOM_PALETTE?.Tag?.orange,
            main: {
                background: 'rgba(254, 235, 215, 1)',
                border: 'rgba(235, 127, 16, 1)',
                color: 'rgba(134, 72, 9, 1)',
                ...CUSTOM_PALETTE?.Tag?.orange?.main
            },
            contrasted: {
                background: 'rgba(168, 91, 12, 1)',
                border: 'rgba(168, 91, 12, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.orange?.contrasted
            }
        },
        pink: {
            ...CUSTOM_PALETTE?.Tag?.pink,
            main: {
                background: 'rgba(251, 233, 239, 1)',
                border: 'rgba(228, 122, 158, 1)',
                color: 'rgba(169, 27, 75, 1)',
                ...CUSTOM_PALETTE?.Tag?.pink?.main
            },
            contrasted: {
                background: 'rgba(211, 35, 95, 1)',
                border: 'rgba(211, 35, 95, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.pink?.contrasted
            }
        },
        purple: {
            ...CUSTOM_PALETTE?.Tag?.purple,
            main: {
                background: 'rgba(242, 234, 253, 1)',
                border: 'rgba(179, 134, 241, 1)',
                color: 'rgba(111, 56, 185, 1)',
                ...CUSTOM_PALETTE?.Tag?.purple?.main
            },
            contrasted: {
                background: 'rgba(139, 71, 233, 1)',
                border: 'rgba(139, 71, 233, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.purple?.contrasted
            }
        },
        teal: {
            ...CUSTOM_PALETTE?.Tag?.teal,
            main: {
                background: 'rgba(213, 243, 238, 1)',
                border: 'rgba(27, 175, 149, 1)',
                color: 'rgba(15, 100, 85, 1)',
                ...CUSTOM_PALETTE?.Tag?.teal?.main
            },
            contrasted: {
                background: 'rgba(19, 125, 106, 1)',
                border: 'rgba(19, 125, 106, 1)',
                color: 'rgba(255, 255, 255, 1)',
                ...CUSTOM_PALETTE?.Tag?.teal?.contrasted
            }
        }
    },
    Combobox: {
        expander: 'rgba(34, 36, 41, 1)',
        fieldSet: {
            hover: 'rgba(51, 96, 246, 1)',
            color: 'rgba(0, 0, 0, 0.15)'
        },
        textinput: {
            background: 'rgba(255, 255, 255, 1)'
        },
        popper: {
            background: 'rgba(255, 255, 255, 1)'
        }
    },
    SingleSelect: {
        primary: {
            background: 'rgba(255, 255, 255, 1)',
            color: 'rgba(34, 36, 41, 1)',
            fieldSet: 'rgba(0, 0, 0, 0.15)',
            fieldSetHover: 'rgba(51, 96, 246, 1)',
            expander: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.SingleSelect?.primary
        },
        secondary: {
            background: 'rgba(250, 250, 250, 1)',
            color: 'rgba(34, 36, 41, 1)',
            fieldSet: 'rgba(0, 0, 0, 0.15)',
            fieldSetHover: 'rgba(51, 96, 246, 1)',
            expander: 'rgba(34, 36, 41, 1)',
            ...CUSTOM_PALETTE?.SingleSelect?.secondary
        }
    },
    loader: {
        main: 'rgba(249, 250, 251, 1)',
        color: 'rgba(34, 43, 45, 1)',
        ...CUSTOM_PALETTE?.loader
    },
    body: {
        background: 'rgba(249, 250, 251, 1)',
        ...CUSTOM_PALETTE?.body
    },
    leftPanel: {
        background: 'rgba(249, 250, 251, 1)',
        hover: 'rgba(0, 0, 0, 0.05)',
        hoverColor: 'rgba(34, 36, 41, 1)',
        color: 'rgba(0, 0, 0, 0.6)',
        selected: 'rgba(0, 0, 0, 0.1)',
        selectedBorder: 'rgba(51, 96, 246, 1)',
        selectedColor: 'rgba(34, 36, 41, 1)',
        ...CUSTOM_PALETTE?.leftPanel
    },
    toolbar: {
        background: 'rgba(255, 255, 255, 1)',
        color: 'rgba(34, 36, 41, 1)',
        item: {
            color: 'rgba(0, 0, 0, 0.6)',
            hoverColor: 'rgba(34, 36, 41, 1)',
            background: 'rgba(255, 255, 255, 1)',
            hover: 'rgba(0, 0, 0, 0.1)'
        },
        ...CUSTOM_PALETTE?.toolbar
    },
    Magnet: {
        border: 'rgba(0, 0, 0, 0.15)'
    },
    background: {
        transparent: 'transparent',
        boxShadow: 'rgba(149, 157, 165, 0.2)',
        body: 'rgba(249, 250, 251, 1)',
        main: '#F7F9FA',
        layer: {
            main: {
                main: '#FFFFFF',
                hover: '#FAFAFA',
                active: '#EBEEEF',
                ...CUSTOM_PALETTE?.background?.layer?.main
            },
            alt: {
                main: '#F7F9FA',
                hover: '#F7F9FA',
                active: '#EBEEEF',
                ...CUSTOM_PALETTE?.background?.layer?.alt
            },
            ...CUSTOM_PALETTE?.background?.layer
        },
        success: '#BCF453',
        alert: '#FF9789',
        warning: 'rgba(214, 129, 0, 1)',
        info: '#80CDFF',
        ...CUSTOM_PALETTE?.background
    },
    text: {
        primary: '#222B2D',
        secondary: '#6E7781',
        placeholder: '#909498',
        error: '#D10000',
        disabled: '#85888A',
        legend: 'rgba(97, 94, 131, 1)',
        contrasted: {
            primary: '#FFFFFF',
            disabled: '#85888A',
            ...CUSTOM_PALETTE?.text?.contrasted
        },
        ...CUSTOM_PALETTE?.text
    },
    accent: {
        info: 'rgba(121, 151, 249, 1)',
        success: 'rgba(95, 175, 0, 1)',
        warning: 'rgba(178, 155, 3, 1)',
        alert: 'rgba(245, 115, 115, 1)',
        ...CUSTOM_PALETTE?.accent
    },
    field: {
        border: 'rgba(0, 0, 0, 0.1)',
        main: '#FFFFFF',
        hover: '#F7F9FA',
        disabled: '#EBEEEF',
        ...CUSTOM_PALETTE?.field
    },
    icon: {
        primary: '#222B2D',
        secondary: '#6E7781',
        interactive: '#FFFFFF',
        disabled: '#85888A',
        contrasted: {
            primary: '#FFFFFF',
            disabled: '#85888A',
            ...CUSTOM_PALETTE?.icon?.contrasted
        },
        ...CUSTOM_PALETTE?.icon
    },
    border: {
        subtle: {
            main: 'rgba(0, 0, 0, 0.1)',
            alt: '#F7F9FA',
            ...CUSTOM_PALETTE?.border?.subtle
        },
        strong: {
            main: '#C3C5C5',
            alt: '#C3C5C5',
            ...CUSTOM_PALETTE?.border?.strong
        },
        interactive: '#ED0000',
        disabled: '#85888A',
        ...CUSTOM_PALETTE?.border
    },
    data: [
        '#ED9A9A',
        '#F48FB1',
        '#CE93D8',
        '#B39DDB',
        '#9FA8DA',
        '#90CAF9',
        '#80DEEA',
        '#80CBC4',
        '#C5E1A5',
        '#E6EE9C',
        '#FFF59D',
        '#FFCC80',
        '#FFAB91',
        '#ED0000',
        '#E91E63',
        '#9C27B0',
        '#673AB7',
        '#3F51B5',
        '#2196F3',
        '#009EB3',
        '#80CBC4',
        '#6FA136',
        '#87931A',
        '#D7C100',
        '#D68100',
        '#FF5722',
        '#A30000',
        '#AD1457',
        '#6A1B9A',
        '#4527A0',
        '#283593',
        '#1565C0',
        '#00838F',
        '#00695C',
        '#547A29',
        '#5C6411',
        '#9B8B00',
        '#AA6600',
        '#DD3400'
    ],
    overlay: 'rgba(51, 51, 51, 0.5)',
    grey: {
        default: '#6c757d',
        dark: '#343a40',
        '100': '#f8f9fa',
        '200': '#e9ecef',
        '300': '#dee2e6',
        '400': '#ced4da',
        '500': '#adb5bd',
        '600': '#6c757d',
        '700': '#495057',
        '800': '#343a40',
        '900': '#212529'
    },
    custom: {
        ...CUSTOM_PALETTE?.custom
    }
}

export default PALETTE